import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarClock, Eye, X } from "lucide-react";
import { useMaintenance } from "@/context/MaintenanceContext";
import { fmtRange, fmtRelative, tzAbbr, viewerTz } from "@/lib/time";

const key = (u) => `cm_mb_${u?.window_id}_${u?.start}`;
const dismissed = (u) => { try { return sessionStorage.getItem(key(u)) === "1"; } catch (e) { return false; } };

export const MaintenanceBanner = () => {
  const { status } = useMaintenance();
  const u = status?.upcoming;
  const [hidden, setHidden] = useState(false);
  const show = u && !status?.active && !hidden && !dismissed(u);
  const tz = viewerTz();
  const close = () => { try { sessionStorage.setItem(key(u), "1"); } catch (e) { /* ignore */ } setHidden(true); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="maintenance-banner" initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[55] mx-auto flex max-w-3xl items-start gap-3 bg-[#0A0A0A] px-4 py-3.5 text-white shadow-2xl sm:items-center sm:px-5">
          <CalendarClock className="mt-0.5 h-5 w-5 shrink-0 text-[#E62314] sm:mt-0" />
          <p className="flex-1 text-sm leading-snug">
            <strong>Scheduled maintenance {fmtRelative(u.start)}.</strong>{" "}
            <span className="text-zinc-300" data-testid="maintenance-banner-time">The site will be unavailable {fmtRange(u.start, u.end, tz)} ({tzAbbr(u.start, tz)}, your time).</span>
          </p>
          <button onClick={close} aria-label="Dismiss" data-testid="maintenance-banner-dismiss" className="rounded-full p-1.5 transition-colors hover:bg-white/15"><X className="h-4 w-4" /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const PreviewPill = () => {
  const { status } = useMaintenance();
  if (!status?.preview || !status?.would_be_active) return null;
  return (
    <div data-testid="maintenance-preview-pill" className="fixed left-1/2 top-24 z-[55] flex -translate-x-1/2 items-center gap-2 rounded-full bg-[#E62314] px-4 py-2 text-xs font-bold text-white shadow-xl">
      <Eye className="h-4 w-4" />Private preview · the site is offline to the public
    </div>
  );
};
